import Cookies from 'js-cookie'
import { ProcessingResult } from '../ProcessingResult'
import { IampLogger, LogTag } from '../../../utils/IampLogger'

// Debug results
import debugTimeAnalysisData from '../../../test/da_brat_time_analysis.json'
//import debugTimeAnalysisData from '../../../test/Thumping_Underground_SunoV4_time_analysis_vocals.json'

export const AiMusicDetectorCookie = {
  Confidence: 'aim_detector_confidence',
  FileName: 'aim_detector_file',
  IasUrl: 'aim_detector_ias',
  IsAi: 'aim_detector_is_ai',
  JobId: 'aim_detector_job_id',
  ProcessingIsoDate: 'aim_detector_date',
  SuspectedModel: 'aim_detector_model',
  TimeAnalysis: 'aim_detector_time_analysis',
}

export class AiMusicDetectorResult extends ProcessingResult {
  confidence: number | undefined
  isAi: boolean | undefined
  suspectedModel: string | undefined
  modelVersion: string | undefined
  timeAnalysis: any

  constructor(data?: {
    confidence?: number
    fileName?: string
    jobId?: string
    iasUrl?: string
    isAi?: boolean
    processingIsoDate?: string
    suspectedModel?: string
    modelVersion?: string
    userId?: string
    timeAnalysis?: any
  }) {
    super({
      fileName: data?.fileName,
      jobId: data?.jobId,
      processingIsoDate: data?.processingIsoDate,
      userId: data?.userId,
    })

    this.confidence = data?.confidence
    this.isAi = data?.isAi
    this.suspectedModel = data?.suspectedModel
    this.modelVersion = data?.modelVersion
    this.timeAnalysis = data?.timeAnalysis
  }

  isComplete() {
    return undefined != this.isAi
  }

  hasProcessingJob() {
    return this.jobId != undefined
  }

  getSavedJobId() {
    return Cookies.get(AiMusicDetectorCookie.JobId)
  }

  save() {
    super.save()
    super.setOrRemoveCookie(AiMusicDetectorCookie.Confidence, this.confidence)
    super.setOrRemoveCookie(AiMusicDetectorCookie.FileName, this.fileName)
    super.setOrRemoveCookie(AiMusicDetectorCookie.IasUrl, this.iasUrl)
    super.setOrRemoveCookie(AiMusicDetectorCookie.IsAi, this.isAi)
    super.setOrRemoveCookie(AiMusicDetectorCookie.JobId, this.jobId)
    super.setOrRemoveCookie(
      AiMusicDetectorCookie.ProcessingIsoDate,
      this.processingIsoDate
    )
    super.setOrRemoveCookie(
      AiMusicDetectorCookie.SuspectedModel,
      this.suspectedModel
    )
    super.setOrRemoveCookie(
      AiMusicDetectorCookie.TimeAnalysis,
      encodeURIComponent(JSON.stringify(this.timeAnalysis))
    )
  }

  load() {
    super.load()
    this.confidence = Cookies.get(AiMusicDetectorCookie.Confidence)
      ? parseFloat(Cookies.get(AiMusicDetectorCookie.Confidence)!)
      : undefined

    this.iasUrl = Cookies.get(AiMusicDetectorCookie.IasUrl)

    this.isAi =
      Cookies.get(AiMusicDetectorCookie.IsAi) !== undefined
        ? Cookies.get(AiMusicDetectorCookie.IsAi) === 'true'
        : undefined

    this.jobId = Cookies.get(AiMusicDetectorCookie.JobId)
    this.fileName = Cookies.get(AiMusicDetectorCookie.FileName)
    this.processingIsoDate = Cookies.get(
      AiMusicDetectorCookie.ProcessingIsoDate
    )
    this.suspectedModel = Cookies.get(AiMusicDetectorCookie.SuspectedModel)
    const strTimeAnalysis = Cookies.get(AiMusicDetectorCookie.TimeAnalysis)
    if (typeof strTimeAnalysis == 'string') {
      try {
        this.timeAnalysis = JSON.parse(decodeURIComponent(strTimeAnalysis))
      } catch (e) {
        IampLogger.error(
          LogTag.HomePage,
          'Error when loading stringified JSON for timeAnalysis:',
          e
        )
        IampLogger.error(
          LogTag.HomePage,
          'TimeAnalysis data in cookies:',
          strTimeAnalysis
        )
      }
    }
  }

  static cleanSavedData() {
    super.cleanSavedData()
    Cookies.remove(AiMusicDetectorCookie.Confidence)
    Cookies.remove(AiMusicDetectorCookie.FileName)
    Cookies.remove(AiMusicDetectorCookie.IasUrl)
    Cookies.remove(AiMusicDetectorCookie.IsAi)
    Cookies.remove(AiMusicDetectorCookie.JobId)
    Cookies.remove(AiMusicDetectorCookie.ProcessingIsoDate)
    Cookies.remove(AiMusicDetectorCookie.SuspectedModel)
    Cookies.remove(AiMusicDetectorCookie.TimeAnalysis)
  }

  setDebugData() {
    super.setDebugData()
    this.confidence = 0.5
    this.isAi = false
    this.timeAnalysis = debugTimeAnalysisData
  }
}
